import { useCallback } from "react";
import { handleDragStart, handleDragOver, handleDrop, handleDragEnd } from "../../utils";

interface UseDragDropCallbacksProps {
  draggedColumn: string | null;
  columnOrder: string[];
  /**
   * Takes a plain array, never an updater: `handleDrop` builds the whole new
   * order from `columnOrder` before calling it, and the table's column order can
   * come from the ColumnManager context, whose setter has no updater form.
   */
  setColumnOrder: (order: string[]) => void;
  setDraggedColumn: (columnId: string | null) => void;
}

export function useDragDropCallbacks({
  draggedColumn,
  columnOrder,
  setColumnOrder,
  setDraggedColumn,
}: UseDragDropCallbacksProps) {
  const handleDragStartCallback = useCallback(
    (e: React.DragEvent, columnId: string) => {
      handleDragStart(e, columnId, setDraggedColumn);
    },
    [setDraggedColumn]
  );

  const handleDragOverCallback = useCallback((e: React.DragEvent) => {
    handleDragOver(e);
  }, []);

  const handleDropCallback = useCallback(
    (e: React.DragEvent, targetColumnId: string) => {
      handleDrop(e, targetColumnId, draggedColumn, columnOrder, setColumnOrder, setDraggedColumn);
    },
    [draggedColumn, columnOrder, setColumnOrder, setDraggedColumn]
  );

  const handleDragEndCallback = useCallback(() => {
    handleDragEnd(setDraggedColumn);
  }, [setDraggedColumn]);

  return {
    handleDragStartCallback,
    handleDragOverCallback,
    handleDropCallback,
    handleDragEndCallback,
  };
}
